import { FEATURE_FLAG_DOMAIN } from '@heidi/runtime/feature-flags';
import { OpenFeature } from '@openfeature/react-sdk';

export const TOKENLESS_401_LOGOUT_GUARD_KILL_SWITCH_KEY =
  'op-scribe-disable-tokenless-401-logout-guard';

/**
 * Operational kill switch for the request-time bearer guard in Scribe HTTP
 * 401 handling. When ON, tokenless 401s follow the previous refresh/logout
 * behavior. Default OFF so an unresolved or unavailable flag provider keeps
 * the safer non-destructive guard enabled.
 *
 * Kill switch, not an experiment - do not add manual exposure tracking.
 */
export const isTokenless401LogoutGuardKilled = (): boolean =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    TOKENLESS_401_LOGOUT_GUARD_KILL_SWITCH_KEY,
    false
  );
